import script from "./contragent-form.vue?vue&type=script&setup=true&lang=js"
export * from "./contragent-form.vue?vue&type=script&setup=true&lang=js"

import "./contragent-form.vue?vue&type=style&index=0&id=3fac4dac&lang=css"

const __exports__ = script;

export default __exports__